
import { createReducer, on } from '@ngrx/store';
import { loadFormConfig2Data, loadFormConfig2DataSuccess, loadFormConfig2DataFailure } from '../actions/formConfig2.actions';

export interface State {
  formConfig2Data: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  formConfig2Data: [],
  loading: false,
  error: null,
};

export const formConfig2Reducer = createReducer(
  initialState,
  on(loadFormConfig2Data, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadFormConfig2DataSuccess, (state, { formConfig2Data }) => {
    console.log({formConfig2Data})
    return ({
    ...state,
    loading: false,
    formConfig2Data: formConfig2Data,
  })}),
  on(loadFormConfig2DataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
